module.exports = __webpack_public_path__ + "static/media/hero_img_mapping.e12a0d7d.png";